/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Display_LabelInputs */

const en_styles_display_label = /** @type {(inputs: Styles_Display_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display`)
};

const fr_styles_display_label = /** @type {(inputs: Styles_Display_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affichage`)
};

const de_styles_display_label = /** @type {(inputs: Styles_Display_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzeige`)
};

const it_styles_display_label = /** @type {(inputs: Styles_Display_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display`)
};

const ru_styles_display_label = /** @type {(inputs: Styles_Display_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отображать`)
};

const es_styles_display_label = /** @type {(inputs: Styles_Display_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar`)
};

const zh_cn2_styles_display_label = /** @type {(inputs: Styles_Display_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`展示`)
};

const ja_styles_display_label = /** @type {(inputs: Styles_Display_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面`)
};

const hi_styles_display_label = /** @type {(inputs: Styles_Display_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रदर्शन`)
};

const pt_pt2_styles_display_label = /** @type {(inputs: Styles_Display_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar`)
};

/**
* | output |
* | --- |
* | "Display" |
*
* @param {Styles_Display_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_display_label = /** @type {((inputs?: Styles_Display_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Display_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_display_label(inputs)
	if (locale === "de") return de_styles_display_label(inputs)
	if (locale === "it") return it_styles_display_label(inputs)
	if (locale === "ru") return ru_styles_display_label(inputs)
	if (locale === "es") return es_styles_display_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_display_label(inputs)
	if (locale === "ja") return ja_styles_display_label(inputs)
	if (locale === "hi") return hi_styles_display_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_display_label(inputs)
	return en_styles_display_label(inputs)
});